const getConfig = () => ({ publicRuntimeConfig: { CLIENT_API_URL: '/api' } });

export default getConfig;
